// Global styles
require('./src/styles/globals.css')
require('./src/styles/prism.css')
require('katex/dist/katex.min.css')

